import { Navigate } from 'react-router-dom';

import { useAuth } from './AuthProvider';
import { PageSpinner } from './PageSpinner';

export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const { initializing, isAuthenticated } = useAuth();

  if (initializing) return <PageSpinner />;
  if (isAuthenticated) return <Navigate to="/curriculum" replace />;

  return <>{children}</>;
}
